import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getError } from '../reducers/main/mainReducer';
import { Box } from '@mui/material';
import { NotificationModel } from '../reducers/main/mainModel';
import { closeErrorSaga } from '../sagas/dataSaga/dataSagaActions';
import { AlertComponent } from '../components/AlertComponent';

export const withErrorMessage = <T extends Record<string, unknown>>(
  Component: React.ComponentType<T>
): React.FC<T> => (props) => {
  const dispatch = useDispatch();

  const alerts = useSelector(getError);
  const onClose = React.useCallback((error: NotificationModel) => {
    dispatch(closeErrorSaga(error))
  }, [dispatch]);
  const handleClose = React.useCallback((item: NotificationModel) => {
    setTimeout(() => onClose(item), 500);
  }, [onClose]);

  React.useEffect(() => {
    alerts.forEach(x => {
      if (x.markAsClosed) {
        handleClose(x);
      }
    })
  }, [alerts, handleClose])

  return <>
    <Box sx={{
      position: 'fixed',
      top: 0,
      right: 0,
      zIndex: 9999,
      padding: alerts.length > 0 ? '15px 15px 0 0' : '0',
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      alignItems: 'flex-end',
      width: '100%',
      maxWidth: '400px',
    }} >
      {alerts.map((x, i) => {
        return <AlertComponent key={i} notification={x} onClose={handleClose} />
      })}
    </Box>
    <Component {...props as T} />
  </>
}